// import { uploadUrl } from './config'

export const wishStatus = [
  {
    label: '所有',
    value: ''
  }, {
    label: '未認養',
    value: 'on'
  }, {
    label: '已認養',
    value: 'end'
  }, {
    label: '認養已送達',
    value: 'done'
  }
]

export const wishNoOrder = [
  {
    label: '升序',
    value: 'wish_no_asc',
    id: 1
  }, {
    label: '降序',
    value: 'wish_no_desc',
    id: 2
  }
]

export const userIdOrder = [
  { label: '升序', value: 'sort_id_asc' },
  { label: '降序', value: 'sort_id_desc' }
]

export const userRestrictionTypes = [
  { label: '所有', value: '' },
  { label: '停權', value: 'DISABLE' },
  { label: '調查中', value: 'INVESTIGATE' },
  { label: 'GC代贈停權', value: 'DISABLE_LOVE' },
  { label: '閃送停權', value: 'LIMIT_PUBLISH_FLASH' }
]

export const userLastLoginOrder = [
  { label: '升序', value: 'sort_last_login_asc' },
  { label: '降序', value: 'sort_last_login_desc' }
]

export const wishTimeOrder = [
  {
    label: '升序',
    value: 'updated_at_asc',
    id: 1
  }, {
    label: '降序',
    value: 'updated_at_desc',
    id: 2
  }
]

export const valuation = [
  {
    text: '0~500元',
    value: 0
  }, {
    text: '500~1000元',
    value: 500
  }, {
    text: '1000~5000元',
    value: 1000
  }, {
    text: '5000~10000元',
    value: 5000
  }, {
    text: '10000~50000元',
    value: 10000
  }, {
    text: '50000元以上',
    value: 50000
  }
]

// 实名验证常量
export const idStatus = [
  {
    label: '所有'
  }, {
    label: '未驗證'
  }, {
    label: '已驗證'
  }, {
    label: '驗證失敗'
  }
]

// 会员变更身份常量
export const verifyStatus = [
  {
    label: '所有'
  }, {
    label: '未審核'
  }, {
    label: '未通過'
  }, {
    label: '通過'
  }
]

// 登入方式
export const loginTypes = [
  { label: '手機', value: 'PHONE' },
  { label: '電子郵件', value: 'EMAIL' },
  { label: 'GOOGLE', value: 'GOOGLE' },
  { label: 'FACEBOOK', value: 'FACEBOOK' }
]

// 后端已提供该接口，暂时不从这里拿数据，commonConfig mixin
export const roleList = [
  {
    label: '一般會員',
    value: 'normal',
    id: 36
  }, {
    label: '關懷會員',
    value: 'care',
    id: 31
  }, {
    label: '公益團體',
    value: 'commonweal',
    id: 32
  }, {
    label: '學校單位',
    value: 'school',
    id: 34
  }, {
    label: '政府機關',
    value: 'gov',
    id: 35
  }, {
    label: '企業行號',
    value: 'company',
    id: 33
  }, {
    label: '官方帳號',
    value: 'official',
    id: 51
  }, {
    label: 'GC循環站',
    value: 'gccycle',
    id: 52
  }
]

// 关怀会员相关
export const careInfo = [
  {
    label: '低收入戶'
  }, {
    label: '中收入戶'
  }, {
    label: '殘障手冊'
  }, {
    label: '其他'
  }
]

export const publicGroups = [
  {
    label: '財團法人'
  }, {
    label: '社團法人'
  }, {
    label: '人民團體'
  }, {
    label: '其他'
  }
]

export const storyTypes = [
  {'id': 21, 'title': '公告消息'},
  {'id': 22, 'title': '企業合作'},
  {'id': 23, 'title': '公益合作'},
  {'id': 24, 'title': '公益走訪/地圖'},
  {'id': 25, 'title': '公益迴響'},
  {'id': 26, 'title': '募集滿額'},
  {'id': 27, 'title': '名人分享'},
  {'id': 28, 'title': '公益捐款'},
  {'id': 37, 'title': '媒體報導'}
]

export const hintMsg = {
  loadingText: '玩命加載中...',
  serverErrorMsg: '出錯咯！～請聯繫管理員'
}

export const ckeditorConfig = {
  toolbarGroups: [
    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
    { name: 'forms', groups: [ 'forms' ] },
    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
    { name: 'tools', groups: [ 'tools' ] },
    { name: 'links', groups: [ 'links' ] },
    { name: 'colors', groups: [ 'colors' ] },
    { name: 'insert', groups: [ 'insert' ] },
    '/',
    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
    { name: 'styles', groups: [ 'styles' ] },
    { name: 'others', groups: [ 'others' ] },
    { name: 'about', groups: [ 'about' ] }
  ],
  removeButtons: 'Save,NewPage,Preview,Print,Templates,Cut,Copy,PasteText,Find,Replace,SelectAll,Scayt,Checkbox,Radio,Iframe,TextField,Textarea,Select,Button,ImageButton,HiddenField,Form,Language,Unlink,Flash,SpecialChar,About,ShowBlocks,CreateDiv,Blockquote,PageBreak',
  height: 500,
  extraPlugins: 'youtube',
  pasteFromWordRemoveFontStyles: false,
  pasteFromWordRemoveStyles: false,
  allowedContent: true,
  disallowedContent: 'script; *[on*]'
}

export const needStatus = [
  {
    label: '所有',
    value: '',
    className: ''
  }, {
    label: '進行中',
    value: 'ongoing',
    className: 'color-green'
  }, {
    label: '未開始',
    value: 'pending',
    className: ''
  }, {
    label: '已結案',
    value: 'finish',
    className: 'color-red'
  }, {
    label: '已下架',
    value: 'pull_off',
    className: 'color-gray'
  }
]

export const thingCategory = [
  { value: 1, label: '女裝、女用品' },
  { value: 49, label: '化妝品、保養品' },
  { value: 2, label: '男裝、男用品' },
  { value: 3, label: '圖書、文具、影音' },
  { value: 4, label: '婦幼、童裝、嬰幼' },
  { value: 5, label: '運動、戶外、休閒' },
  { value: 6, label: '居家、餐廚' },
  { value: 7, label: '食品、飲料' },
  { value: 8, label: '家電、視聽' },
  { value: 9, label: '手機、配件' },
  { value: 10, label: '日用、清潔' },
  { value: 11, label: '汽機車周邊' },
  { value: 12, label: '玩具、收藏' },
  { value: 13, label: '電腦、周邊' },
  { value: 14, label: '教學、人力' },
  { value: 15, label: '相機、攝影' },
  { value: 16, label: '票券、點數' },
  { value: 17, label: '電玩相關' },
  { value: 18, label: '寵物相關' },
  { value: 19, label: '家具' },
  { value: 20, label: '其它' }
]

export const loveboxTradeStatuses = [
  { value: 0, label: '已創建' },
  { value: 1, label: '已寄送' },
  { value: 2, label: '交易完成' },
  { value: 3, label: '已感謝' }
]

export const needShipWays = [
  {
    label: '所有',
    value: ''
  }, {
    label: '萊爾富',
    value: 'hilife'
  }, {
    label: '7-11交貨便',
    value: 'seven_eleven'
  }, {
    label: '全家店到店',
    value: 'fami'
  }, {
    label: '新竹物流',
    value: 'hct'
  }, {
    label: '其他物流',
    value: 'others'
  }, {
    label: '面交',
    value: 'meet'
  }, {
    label: '賀盟物流',
    value: 'homeng'
  }, {
    label: '掌櫃',
    value: 'palmbox'
  }, {
    label: 'ｉ郵箱',
    value: 'ibox'
  }, {
    label: '直購',
    value: 'direct_purchase'
  }
]

export const needDealStatus = [
  {
    label: '所有',
    value: ''
  }, {
    label: '索取中',
    value: 'init'
  }, {
    label: '婉拒',
    value: 'pass'
  }, {
    label: '匯款中',
    value: 'remitting'
  }, {
    label: '已匯款',
    value: 'remitted'
  }, {
    label: '等待寄送',
    value: 'received_money'
  }, {
    label: '已寄送',
    value: 'sent'
  }, {
    label: '取消贈送',
    value: 'cancel'
  }, {
    label: '完成',
    value: 'finished'
  }, {
    label: '已感謝',
    value: 'thanks'
  }, {
    label: '確認運送細節',
    value: 'comfirm_ship'
  }, {
    label: '未記錄',
    value: null
  }
]

export const giftDealStatus = [
  { value: 'requesting', label: '索取中' },
  { value: 'pass', label: '婉拒' },
  { value: 'remitting', label: '匯款中' },
  { value: 'remitted', label: '已匯款' },
  { value: 'received_money', label: '等待寄送' },
  { value: 'sent', label: '已寄送' },
  { value: 'cancel', label: '取消贈送' },
  { value: 'finished', label: '完成' },
  { value: 'thanks', label: '已感謝' },
  { value: 'not_obtained', label: '未獲贈' }
]

export const edmStatus = [
  { value: 0, label: '已失效', className: 'color-gray' },
  { value: 1, label: '有效', className: 'color-main' },
  { value: 2, label: '发送中', className: 'color-golden' },
  { value: 3, label: '已发送', className: 'color-green' }
]

export const chlgTagType = [
  {value: '優化', label: '優化'},
  {value: '功能', label: '功能'},
  {value: '修復', label: '修復'}
]

export const fbackType = [
  {
    value: '使用問題回報',
    label: '使用問題回報'
  }, {
    value: '操作流程諮詢',
    label: '操作流程諮詢'
  }, {
    value: '違規行為檢舉',
    label: '違規行為檢舉'
  }, {
    value: '使用回饋建議',
    label: '使用回饋建議'
  }, {
    value: '平台合作提案',
    label: '平台合作提案'
  }, {
    value: '其他',
    label: '其他'
  }
]

// export const fbackStatus = [
//   {
//     label: '所有',
//     value: ''
//   }, {
//     label: '未處理',
//     value: 0
//   }, {
//     label: '已處理',
//     value: 1
//   }
// ]

export const LOVEBOX_ITEM_STATUS = {
  STATUS_DELETED: 0,
  STATUS_ON_SHELVE: 1,
  STATUS_OFF_SHELVE: 2,
  STATUS_FINISH: 3,
  STATUS_HIDDEN: 4
}

export const loveboxItemStatuses = [
  {
    label: '已删除',
    value: 0
  },
  {
    label: '進行中',
    value: 1
  }, {
    label: '已下架',
    value: 2
  }, {
    label: '已完成',
    value: 3
  }, {
    label: '待上架',
    value: 4
  }
]

export const loginError = {
  205: '密碼錯誤請重試！',
  201: '賬戶不存在',
  202: '沒有權限',
  'other': '登入錯誤，賬戶不存在或無權限，如有問題請聯系管理員'
}

export const fbStatusList = [{
  value: 0,
  label: '未查看'
}, {
  value: 1,
  label: '已查看'
}, {
  value: 2,
  label: '已處理'
}]

export const BASE_WISH_YEAR = 2016

export const showOptions = [{
  value: 1,
  label: '不展示隱藏'
}, {
  value: 2,
  label: '只展示隱藏'
}, {
  value: 3,
  label: '展示全部'
}]

export const PAY_TYPE = {
  CREDIT_CARD: '01', // 信用卡
  VIRTUAL_ACCOUNT: '03',
  GREEN_POINT: 'greenpoint'
}

export const PAY_TYPE_TEXTS = {
  [PAY_TYPE.CREDIT_CARD]: '信用卡',
  [PAY_TYPE.VIRTUAL_ACCOUNT]: 'ATM 虛擬帳號',
  [PAY_TYPE.GREEN_POINT]: '綠點兌換'
}

export const PAY_STATUS = {
  INVALID: -1,
  CANCEL: 0,
  CHARGING: 1,
  CHARGED: 2
}

export const PAY_STATUS_TEXTS = {
  [PAY_STATUS.CANCEL]: '已過期',
  [PAY_STATUS.CHARGING]: '待付款',
  [PAY_STATUS.CHARGED]: '儲值完成',
  [PAY_STATUS.INVALID]: '下單失敗'
}

export const WALLET_RECORD_TYPES = {
  CHARGE: 1,
  CONSUME: 2,
  REFUND: 3,
  REWARD: 4,
  RETURN: 5,
  EXCHANGE: 6,
  DEPOSIT_RETURN: 7, // 押金退回
  EXPIRE: 8 // 限時點數到期歸零
}

export const WALLET_DEAL_TYPES = {
  CHARGE: 1,
  GIFT_REQUEST: 2,
  NEED_DONATE: 3,
  SPONSOR: 4,
  LOVE_ORDER: 6,
  EXPRESS: 7,
  FREIGHT_DONATE: 8,
  GC_REWARD: 9
}

export const WALLET_DEAL_TEXT = {
  [WALLET_DEAL_TYPES.GIFT_REQUEST]: '禮物索取',
  [WALLET_DEAL_TYPES.NEED_DONATE]: '需求贈送',
  [WALLET_DEAL_TYPES.SPONSOR]: '心意牆贊助',
  [WALLET_DEAL_TYPES.LOVE_ORDER]: 'GC代贈',
  [WALLET_DEAL_TYPES.EXPRESS]: '分享通'
}

export const PURCHASE_FROM = [
  {label: '用戶提供', value: 0},
  {label: 'momo直購', value: 1}
]

export const REFUND_STATUS = {
  PENDING: 1,
  EXECUTED: 2,
  INVALID: 0
}

export const REFUND_TEXTS = {
  [REFUND_STATUS.PENDING]: '待退點',
  [REFUND_STATUS.EXECUTED]: '已退點',
  [REFUND_STATUS.INVALID]: '已失效'
}

export const USER_RESTRICTION_TYPE = {
  DISABLE: '停權',
  INVESTIGATE: '調查中',
  DISABLE_LOVE: 'GC代贈停權',
  LIMIT_MOMENT: '限制發文中'
}

export const EXPRESS_STATUS = {
  INIT: 'init', // 待完善寄件信息等
  UNPAID: 'unpaid', // 待付運費
  PAID: 'paid',
  SENT: 'sent',
  DONE: 'done',
  CANCELLED: 'cancelled'
}

export const EXPRESS_STATUS_TXT = {
  [EXPRESS_STATUS.INIT]: '待填寫收件資料',
  [EXPRESS_STATUS.UNPAID]: '待付運費',
  [EXPRESS_STATUS.PAID]: '待寄出',
  [EXPRESS_STATUS.SENT]: '待收件',
  [EXPRESS_STATUS.DONE]: '已完成',
  [EXPRESS_STATUS.CANCELLED]: '已取消'
}

export const COUPON_RECORD_STATUS = {
  VALID: 0,
  USED: 1,
  EXPIRED: 2,
  FROZEN: 3
}

export const COUPON_TYPE = {
  NO_THRESHOLD: 0,
  DISCOUNT: 1
}

export const COUPON_VALID_TYPE = {
  TIME: 1,
  DAYS: 2
}

export const WISH_ORGANIZER = {
  KUENTAI: 1,
  VIS: 2,
  WPG: 3,
  MAKALOT: 4,
  MEDIATEK: 5
}

export const COUPON_SCENE = {
  ALL: 0,    // 通用場景
  FLASH: 1,  // 閃送區專用
  LOVEBOX: 2 // GC代贈索取
}

export const ORGANIZER_STATUS = {
  RUNNING: 0,
  LIMIT: 1,
  CLOSE: 2
}

export const ORGANIZER_STATUS_TXT = {
  [ORGANIZER_STATUS.RUNNING]: '',
  [ORGANIZER_STATUS.LIMIT]: '限制中',
  [ORGANIZER_STATUS.CLOSE]: '已關閉'
}

export const STORY_STATUS = {
  DELETE: -1, // 已刪除
  HIDE: 0, // 預上線
  SHOW: 1, // 上架
  OFF: 2 // 下架
}

export const LOVE_ORDER_STATUS = {
  STATUS_CANCEL: -1,
  STATUS_INIT: 0,
  STATUS_UNPAID: 1,
  STATUS_PAID: 2,
  STATUS_SENT: 3,
  STATUS_RECEIVED: 4,
  STATUS_DONE: 5
}

export const LOVE_BOX_STATUS = {
  STATUS_INIT: 0,
  STATUS_SENT: 1,
  STATUS_RECEIVED: 2
}

export const LOVE_ORDER_STATUS_TXT = {
  [LOVE_ORDER_STATUS.STATUS_INIT]: '揀貨中',
  [LOVE_ORDER_STATUS.STATUS_UNPAID]: '待付運費',
  [LOVE_ORDER_STATUS.STATUS_PAID]: '揀貨中',
  [LOVE_ORDER_STATUS.STATUS_SENT]: '已寄出',
  [LOVE_ORDER_STATUS.STATUS_RECEIVED]: '已送達',
  [LOVE_ORDER_STATUS.STATUS_DONE]: '已完成',
  [LOVE_ORDER_STATUS.STATUS_CANCEL]: '已取消'
}

export const LOVE_BOX_STATUS_TXT = {
  [LOVE_BOX_STATUS.STATUS_INIT]: '揀貨中',
  [LOVE_BOX_STATUS.STATUS_SENT]: '已寄出',
  [LOVE_BOX_STATUS.STATUS_RECEIVED]: '已送達'
}

export const RECYCLE_ID_ORDER_STATUS = {
  CREATED: 0,
  ON_TRIAL: 1,
  PAID: 2,
  EXPIRE: 3,
  SUSPENDED: 4,
  SUBSCRIPTION_CANCELED: 5
}

export const RECYCLE_ID_ORDER_STATUS_TXT = {
  [RECYCLE_ID_ORDER_STATUS.CREATED]: '未支付',
  [RECYCLE_ID_ORDER_STATUS.ON_TRIAL]: '試用中',
  [RECYCLE_ID_ORDER_STATUS.PAID]: '已支付',
  [RECYCLE_ID_ORDER_STATUS.EXPIRE]: '已過期',
  [RECYCLE_ID_ORDER_STATUS.SUSPENDED]: '暫停中',
  [RECYCLE_ID_ORDER_STATUS.SUBSCRIPTION_CANCELED]: '取消訂閱'
}

export const RECYCLE_ID_DISCOUNT_TYPE = {
  DISCOUNT_CODE: 0,
  INVITE_CODE: 1
}

export const RECYCLE_ID_DISCOUNT_TYPE_TXT = {
  [RECYCLE_ID_DISCOUNT_TYPE.DISCOUNT_CODE]: '折扣碼',
  [RECYCLE_ID_DISCOUNT_TYPE.INVITE_CODE]: '公益邀請碼'
}

export const RECYCLE_ID_DISCOUNT_STATUS = {
  INVALID: 0,
  VALID: 1
}

export const RECYCLE_ID_DISCOUNT_STATUS_TXT = {
  [RECYCLE_ID_DISCOUNT_STATUS.INVALID]: '無效',
  [RECYCLE_ID_DISCOUNT_STATUS.VALID]: '有效'
}

export const RECYCLE_ID_DISCOUNT_RECORD_STATUS = {
  CREATED: 0,
  USED: 1
}

export const RECYCLE_ID_DISCOUNT_RECORD_STATUS_TXT = {
  [RECYCLE_ID_DISCOUNT_RECORD_STATUS.CREATED]: '試用中待使用',
  [RECYCLE_ID_DISCOUNT_RECORD_STATUS.USED]: '已使用'
}



// WEBPACK FOOTER //
// ./src/utils/constant.js